(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tour-booking"] && !Shopify.designMode) return;
  try {
    class TourBooking extends HTMLElement {
    connectedCallback() {
      this.dateInput = this.querySelector('[data-booking-date]');
      this.timeInput = this.querySelector('[data-booking-time]');
      this.propertyInput = this.querySelector('[data-booking-property]');
      this.error = this.querySelector('[data-booking-error]');
      this.form = document.getElementById(this.dataset.productFormId);
      this.dateInput.min = this.localDate(new Date());
      this.refreshButtons();
      this.addEventListener('change', () => this.validate());
      document.addEventListener('shopify:product:select', (event) => {
        event.promise?.then(() => {
          this.refreshButtons();
          this.validate();
        });
      });
      this.form?.addEventListener('submit', (event) => {
        if (!this.validate()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
    }

    refreshButtons() {
      this.buttons = [
        ...document.querySelectorAll(`[form="${this.dataset.productFormId}"][name="add"]`),
        ...(this.form?.querySelectorAll('[name="add"]') || []),
        ...document.querySelectorAll('.sticky-add-to-cart__button')
      ];
      this.buttons.forEach((button) => {
        if (!button.dataset.bookingRequired) {
          button.dataset.bookingProductDisabled = String(button.disabled);
        }
        button.dataset.bookingRequired = 'true';
        button.disabled = true;
      });
    }

    localDate(date) {
      const offset = date.getTimezoneOffset();
      return new Date(date.getTime() - offset * 60000).toISOString().slice(0, 10);
    }

    validate() {
      const valid = Boolean(this.dateInput.value && this.timeInput.value);
      this.propertyInput.value = valid
        ? `Date: ${this.dateInput.value} | Time: ${this.timeInput.value}`
        : '';
      this.error.hidden = valid || (!this.dateInput.value && !this.timeInput.value);
      this.buttons.forEach((button) => {
        button.disabled = !valid || button.dataset.bookingProductDisabled === 'true';
      });
      return valid;
    }
  }

  if (!customElements.get('tour-booking')) {
    customElements.define('tour-booking', TourBooking);
  }
  } catch(e) { console.error(e); }
})();

})();
